/**
 * Groups goals by their plan year
 * @param {Array} goals - Array of goal objects
 * @returns {Object} Goals grouped by year
 */
export const groupGoalsByYear = goals => {
  return goals.reduce((acc, goal) => {
    const year = goal.planYear;
    return {
      ...acc,
      [year]: [...(acc[year] || []), goal],
    };
  }, {});
};

/**
 * Gets sorted years from grouped goals, always including current year if no goals exist
 * @param {Object} groupedGoals - Goals grouped by year
 * @returns {Array} Array of year strings sorted in descending order
 */
export const getSortedYears = groupedGoals => {
  const currentYear = new Date().getFullYear();
  const goalYears = Object.keys(groupedGoals);

  return goalYears.length > 0
    ? goalYears.sort((a, b) => b - a)
    : [currentYear.toString()];
};

/**
 * Filters goals to only include those with valid planYear
 * @param {Array} goals - Array of goal objects
 * @returns {Array} Filtered goals
 */
export const getDisplayGoals = goals => {
  return goals.filter(goal => goal && goal.planYear);
};
